// Some dependencies (e.g. aws-amplify / amazon-cognito-identity-js / newer @mui packages) assume a Node-like
// `process` global is present at runtime. Older CRA (react-scripts 3.x / webpack 4) tooling doesn't always
// guarantee this shim is wired up for every module, which can surface as `Uncaught ReferenceError: process is
// not defined` in the browser. This file must be imported first (before any other app code) so the shim exists
// before any dependent module executes.
if (typeof window !== 'undefined' && typeof window.process === 'undefined') {
	window.process = { env: {}, browser: true, version: '' };
}

